export default __webpack_public_path__ + "static/media/loader.613f5fb7.gif";